<section>
  <div class="p-6">
    <div>
      <h1 class="mt-7 text-center font-normal">Session Expired Warning</h1>
      <h2 class="mt-7 text-center text-xl font-normal">
        Your session is about to expire due to inactivity! For security reasons,
        you will be logged off in <b>{{ counter$ | async }}</b> seconds.
      </h2>
    </div>
    <div class="mt-8 flex justify-center">
      <button class="btn-primary" (click)="closeDialog(true)" cdkFocusInitial>
        Stay Signed In
      </button>
    </div>
  </div>
</section>
